import axios from 'axios';
import { toast } from 'react-toastify';

// Em testes o mock de axios pode não expor interceptors; registramos os
// nossos apenas quando a API real estiver disponível.
if (axios.interceptors?.request && axios.interceptors?.response) {
  // 1. ANTES DE SAIR: limpa interceptores antigos para evitar duplicação
  axios.interceptors.request.clear();
  axios.interceptors.response.clear();

  // 2. ANTES DE SAIR: anexa token, cod_org e cod_empresa em cada requisição
  axios.interceptors.request.use(
    (config) => {
      const tokenAtual = sessionStorage.getItem('token');
      const codOrg = sessionStorage.getItem('cod_org');
      const codEmpresa = sessionStorage.getItem('cod_empresa');

      if (!config.headers) {
        config.headers = {};
      }

      if (tokenAtual) {
        config.headers.Authorization = tokenAtual;
      }

      if (codOrg) {
        config.headers.cod_org = codOrg;
      }

      if (codEmpresa) {
        config.headers.cod_empresa = codEmpresa;
      }

      // Evita conflito de case sensitive com header legado
      if (config.headers.authorization) {
        delete config.headers.authorization;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  // 3. NA VOLTA: emite evento de logout forçado em erros 401 (exceto login)
  //    e avisa o usuário em erros 403 (sem permissão) — antes disso, uma
  //    ação bloqueada por permissão falhava em silêncio (ex: autocomplete
  //    de transportador na NFe), deixando o usuário sem entender por que
  //    algo não carregava.
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const url = error.config?.url || '';
        if (!url.includes('/login')) {
          window.dispatchEvent(new CustomEvent('auth:force_logout'));
        }
      } else if (
        error.response?.status === 403 &&
        // Senha de exclusão: quem chamou abre ModalSenhaOuAutorizacao, que mostra o erro.
        error.response?.data?.code !== 'SENHA_EXCLUSAO_REQUERIDA'
      ) {
        // Alguns controllers (ex: verificarLojaAberta) retornam a mensagem em
        // "msg" em vez de "message" — sem esse fallback, o motivo real do
        // bloqueio (loja fechada) era mascarado por um texto genérico de permissão.
        const mensagem =
          error.response?.data?.message ||
          error.response?.data?.msg ||
          'Você não tem permissão para realizar esta ação.';
        toast.error(mensagem);
      }
      return Promise.reject(error);
    }
  );
}

export default axios;
